const TYPES = require('reducers/socialInfo').ACTION_TYPES;
const Storage = require('utils/localStorage/Storage');
const LOCAL_STORAGE = require('utils/localStorage/Constants');

module.exports = {
    TYPES,

    setUserSocialInfo: function (data) {
        Storage.local.setItem(LOCAL_STORAGE.LITHIUM_DATA, data);
        return {
            type: TYPES.SET_USER_SOCIAL_INFO,
            socialInfo: data
        };
    },

    setLithiumSuccessStatus: function (data) {
        return {
            type: TYPES.SET_LITHIUM_SUCCESS_STATUS,
            isLithiumSuccessful: data
        };
    }
};
